import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { assertDatesForComparision } from '../helper/assert-dates-for-comparision.function';

/**
 * Returns true if a is between lower and upper (chronologically).
 * Accepts ISO date/time strings (date, time, datetime, with/without timezone).
 * Throws for invalid input.
 */
export function isBetween<T extends IsoDate | IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(a: T, lower: T, upper: T): boolean {
  const [da, dLower, dUpper] = assertDatesForComparision(a, lower, upper);
  return da.getTime() >= dLower.getTime()
      && da.getTime() <= dUpper.getTime();
}

